// Imports
import Swiper from "swiper/bundle";

// Make it globally available
window.Swiper = Swiper;
